import normalizeMappingName from './normalizeMappingName';

const PARENT_SKU_SYNONYMS = new Set([
  'parent sku',
  'parent_sku',
  'parentsku',
  'parents sku',
  'parent product sku',
  'parent_product_sku',
]);

export function detectParentSkuColumn(fileColumns) {
  if (!Array.isArray(fileColumns) || !fileColumns.length) {
    return null;
  }

  const match = fileColumns.find((columnName) => (
    PARENT_SKU_SYNONYMS.has(normalizeMappingName(columnName))
  ));

  return match ?? null;
}
